export default "__VITE_ASSET__3espn05c__"